import { useTranslation } from 'react-i18next';
import { ClosingHiredCard } from '@components/Closing/ClosingHiredCard';

export const ClosingBody = ({ closings, jobId }) => {
  const { t } = useTranslation();

  return (
    closings.length > 0 && (
      <>
        <p className="rev-o-typo-primary-level-3 rev-u-typo-w-primary-medium rev-u-lh-copy rev-u-color-grey-60 rev-u-mb-16">
          {t('closing.bingoHeader.label')}
        </p>

        <div className="o-grid-auto-fit">
          {closings.map(closing => (
            <ClosingHiredCard
              closing={closing}
              jobId={jobId}
              key={closing.id}
            />
          ))}
        </div>
      </>
    )
  );
};
